<template>
  <div id="layout-header">
    <app-menu></app-menu>
    <div class="uk-inline">
      <vk-icon icon="search" class="uk-form-icon uk-form-icon-flip"></vk-icon>
      <form @submit.prevent="search">
        <input type="text" name="search" class="uk-input" v-model="searchText" @blur="search">
      </form>
    </div>
    <vk-button class="button" icon="cart" ratio="1" @click="clickCartButton">
      <img src="../assets/img/image6.png" height="20" width="20"/>
      <span class="badge" v-show="cartCount">{{ cartCount }}</span>
    </vk-button>
  </div>
</template>

<script>
  import AppMenu from './header/AppMenu.vue';
  export default {
    name: 'app-header',
    components: {
      AppMenu,
    },
    data () {
      return {
        searchText: '',
      };
    },
    computed: {
      cartCount () {
        return this.$store.state.cart.length;
      }
    },
    methods: {
      clickCartButton () {
        if (!this.cartCount) return;
        this.$router.push({'path': '/cart'}, ()=>{});
      },
      search () {
        if (this.searchText.trim() !== '') {
          this.$router.push({'path': `/search_result/${this.searchText}/`}, ()=>{});
        }
      }
    },
    created () {
      if (this.$route.params.searchText) {
        this.searchText = this.$route.params.searchText;
      }
      // 料金計算設定を読み込み
      this.$store.dispatch('setPriceCalculation');
    }
  };
</script>

<style scoped lang="scss">
  #layout-header {
    background-color: rgb(89, 89, 89);
    padding: 4px 10px;
    display: flex;
    justify-content: space-between;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1030;
    .uk-input {
      border-radius: 20px;
    }
    .uk-inline {
      margin: 0 10px;
    }
    .button {
      background-color: #fff;
      color: #666;
      border-radius: 10px;
      width: 3rem;
      padding: 0;
    }
  }

  .badge {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #ff0000;
    color: #f0f0f0;
    border-radius: 1rem;
    font-size: 1rem;
  }
</style>
